import router from '@/router'
import { defaultBungieOAuth } from '@/utils/auth'

export const loginFromCode = ({commit, dispatch}, {code}) => {
  return defaultBungieOAuth.getTokens(code).then(token => {
    const payload = {
      bungieToken: token.access_token,
      membershipId: token.membership_id
    }
    commit('setBungieToken', payload)
    commit('setMembershipId', payload)
    const tokenExpiration = new Date().getTime() + token.expires_in * 1000
    commit('setTokenExpiration', {tokenExpiration})
    return true
  })
}

export const login = ({commit}) => {
  defaultBungieOAuth.login()
}

export const logout = ({commit}) => {
  commit('setBungieToken', {bungieToken: null})
  commit('setMembershipId', {membershipId: null})
  commit('setTokenExpiration', {tokenExpiration: false})
  commit('clearFetchedData', null, {root: true})
  router.push({name: 'home'})
}



// WEBPACK FOOTER //
// ./src/store/auth/actions.js